import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Settings } from './settings.model';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  settings$: Observable<Settings>;
  private settings: BehaviorSubject<Settings>;

  constructor() {
    this.settings = new BehaviorSubject<Settings>(null);
    this.settings$ = this.settings.asObservable();
  }

  getSettings(): Settings {
    return this.settings.value;
  }

  setSettings(settings: Settings): void {
    this.settings.next(settings);
  }
}
